import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { toJS } from "mobx";

export async function getLogCalls({
  phoneNumber,
  callerName,
  direction,
  createdBy,
  modifiedBy,
  callStatus,
  admin,
  schedule,
  callPurpose,
  createdDate,
  createdDateStart,
  createdDateEnd,
  updatedDate,
  updatedDateStart,
  updatedDateEnd,
  appointmentDate,
  appointmentDateStart,
  appointmentDateEnd,
  scheduleDateStart,
  scheduleDateEnd,
  scheduledatevariable,
  appointmentdatevariable,
  updateddatevariable,
  createddatevariable,
  archived,
  limit,
  page,
  sortBy
}) {
  try {
    if (callPurpose) {
      callPurpose = toJS(callPurpose);
    }

    let response = await axios.Get({
      url: `${adminUrl}/logcalls?phoneNumber=${phoneNumber ||
        ""}&callerName=${callerName || ""}&direction=${direction ||
        ""}&createdBy=${createdBy || ""}&modifiedBy=${modifiedBy ||
        ""}&callStatus=${callStatus || ""}&admin=${admin ||
        ""}&schedule=${schedule || ""}&createdDate=${createdDate ||
        ""}&createddatevariable=${createddatevariable ||
        ""}&createdDateStart=${createdDateStart ||
        ""}&createdDateEnd=${createdDateEnd || ""}&updatedDate=${updatedDate ||
        ""}&updateddatevariable=${updateddatevariable ||
        ""}&updatedDateStart=${updatedDateStart ||
        ""}&updatedDateEnd=${updatedDateEnd ||
        ""}&appointmentdatevariable=${appointmentdatevariable ||
        ""}&appointmentDateStart=${appointmentDateStart ||
        ""}&appointmentDateEnd=${appointmentDateEnd ||
        ""}&scheduledatevariable=${scheduledatevariable ||
        ""}&scheduleDateStart=${scheduleDateStart ||
        ""}&scheduleDateEnd=${scheduleDateEnd ||
        ""}&appointmentDate=${appointmentDate || ""}&archived=${archived || false}&limit=${limit ||
        ""}&page=${page || ""}&callPurpose=${JSON.stringify(callPurpose) || ""}&sortBy=${sortBy || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function createLogCall({
  phoneNumber,
  alternativePhoneNumber,
  callerName,
  callStatus,
  callerEmail,
  admin,
  description,
  direction,
  convenientHour,
  appointmentDate,
  userName,
  userRole,
  userId,
  outbond,
  QAReferrer,
  QAReferrerOther,
  callPurpose,
  chatId,
  oaReportId
}) {
  let name = userName;
  let role = userRole;


  try {
    let response = await axios.Post({
      url: `${adminUrl}/logcalls`,
      data: {
        phoneNumber,
        alternativePhoneNumber,
        callerName,
        callStatus,
        callerEmail,
        admin,
        description,
        direction,
        convenientHour,
        appointmentDate,
        relatedTo: { userId, role, name },
        outbond,
        QAReferrer,
        QAReferrerOther,
        callPurpose,
        chatId,
        oaReportId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getLogCallDetail(logCallId) {
  let logcallId = logCallId;
  try {
    let response = await axios.Get({
      url: `${adminUrl}/logcalls/${logcallId}`,
      data: { logcallId }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function updateLogCall({
  logCallId,
  phoneNumber,
  alternativePhoneNumber,
  callerName,
  callStatus,
  callerEmail,
  admin,
  description,
  direction,
  convenientHour,
  appointmentDate,
  userName,
  userRole,
  userId,
  outbond,
  QAReferrer,
  QAReferrerOther,
  callPurpose
}) {
  let logcallId = logCallId;
  let name = userName;
  let role = userRole;


  try {
    let response = await axios.Put({
      url: `${adminUrl}/logcalls/${logcallId}`,
      data: {
        phoneNumber,
        alternativePhoneNumber,
        callerName,
        callStatus,
        callerEmail,
        admin,
        description,
        direction,
        convenientHour,
        appointmentDate,
        relatedTo: userId ? { userId, role, name } : null,
        outbond,
        QAReferrer,
        QAReferrerOther,
        callPurpose
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function deleteLogcall(logCallId) {
  let logcallId = logCallId;
  try {
    let response = await axios.Put({
      url: `${adminUrl}/logcalls/delete/${logcallId}`,
      data: {}
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getTodayLatestLogcall(page) {
  try {

    let response = await axios.Get({
      url: `${adminUrl}/notification/logcall?page=${page || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function archiveLogcall(logcalldata) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/logcalls/archivedlogcall/archivelogcall`,
      data: logcalldata
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function deleteArchiveLogcall(logcallid) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/logcalls/archivedlogcall/deletearchivelogcall?logcallid=${logcallid || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function closeLogcall(logcallId) {
  try {
    let response = await axios.Put({
      url: `${adminUrl}/logcalls/close/${logcallId || ""}`,
      data: {
        logcallId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: true };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getArchiveLogcall(logcallId, adminId, notify_list) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/logcalls/archivedlogcall/listarchivelogcalls?logcallsid=${logcallId || ""}&adminid=${adminId || ""}&notify_list=${notify_list || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getListArchivedLogcallIds(adminId, notifyMe) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/logcalls/archivedlogcall/listarchiveids?adminid=${adminId || ""}&notify_me=${notifyMe}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data }
  }
}

export async function updateRecordedLogcallinAnalytics(userid, logcallid) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/logcalls/updatelastrecordedlogcall?userid=${userid}&logcallid=${logcallid}`
    });
    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: response.data };
  } catch (e) {
    return { error: e.response.data }
  }
}
